/**
 * Schmaler fetch-Wrapper. Beachtet:
 *   - credentials: 'include' damit das HttpOnly-Session-Cookie mitgesendet wird
 *   - X-Requested-With Header gegen einfache CSRF-Vektoren (wir checken's serverseitig)
 *   - structured ApiError, nicht bloss new Error(string)
 */
export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public body?: unknown) {
    super(message);
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const headers: Record<string, string> = {
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };
  const init: RequestInit = { method, headers, credentials: 'include' };
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify(body);
  }

  const res = await fetch(path, init);

  // 204 No Content
  if (res.status === 204) return undefined as T;

  let payload: unknown = null;
  const ct = res.headers.get('Content-Type') || '';
  if (ct.includes('application/json')) {
    payload = await res.json().catch(() => null);
  }

  if (!res.ok) {
    const code = (payload as { error?: string } | null)?.error ?? `http_${res.status}`;
    const msg  = (payload as { message?: string } | null)?.message ?? `Request failed: ${res.status}`;
    throw new ApiError(res.status, code, msg, payload);
  }

  return payload as T;
}

export const http = {
  get:    <T>(p: string)                => request<T>('GET',    p),
  post:   <T>(p: string, b?: unknown)   => request<T>('POST',   p, b),
  put:    <T>(p: string, b?: unknown)   => request<T>('PUT',    p, b),
  patch:  <T>(p: string, b?: unknown)   => request<T>('PATCH',  p, b),
  delete: <T>(p: string)                => request<T>('DELETE', p)
};
